// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"be7706c3","333":"7e63caf0"}[chunkId] + ".chunk.js";
};